import { type AxiosPromise } from 'axios';
import { httpWithAuth } from '~/clients';
import { GET_FAVORITES } from '~/constants/endpoints';
import { FavoriteVehicle } from '~/contracts/common';

export default function fetchFavorites(
  controller?: AbortController
): AxiosPromise<FavoriteVehicle[]> {
  return httpWithAuth.get<FavoriteVehicle[]>(GET_FAVORITES, {
    signal: controller?.signal
  });
}
